import React, { useState } from "react";
import { ArticleCommentProperties } from "../../../../types/blog.type";
import { Avatar, Button, Col, List, Row, Space, Typography } from "antd";
import styled from "styled-components";
import Icon, { ArrowRightOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { ReactComponent as Trash } from "../../../../assets/Icons/Trash.svg";

const { Text, Title, Paragraph } = Typography;

interface IProps {
	comment: any;
	onClickShowReply?: () => void;
	onClickRemove?: () => void;
	onClickReply?: (comment: any) => void;
	onClickApprove?: () => void;
	onClickReject?: () => void;
	isReply?: boolean;
	isOpenReply?: boolean;
	showHideContent?: boolean;
}

export default function CommentItem2({
	comment,
	onClickShowReply,
	isReply,
	onClickRemove,
	onClickReply,
	isOpenReply,
	onClickApprove,
	onClickReject,
	showHideContent,
}: IProps) {
	const [expandedState, setExpandedState] = useState({ expanded: false, count: 0 });

	const calculateTimeAgo = (date: Date): string => {
		const now = new Date();
		const secondsAgo = Math.floor((now.getTime() - date.getTime()) / 1000);

		const minutes = Math.floor(secondsAgo / 60);
		const hours = Math.floor(minutes / 60);
		const days = Math.floor(hours / 24);

		if (days > 7) {
			const months = [
				"Januari",
				"Februari",
				"Maret",
				"April",
				"Mei",
				"Juni",
				"Juli",
				"Agustus",
				"September",
				"October",
				"November",
				"Desember",
			];

			const day = String(date.getDate()).padStart(2, "0");
			const month = months[date.getMonth()];
			const year = date.getFullYear();

			return `${day} ${month} ${year}`;
		}

		if (days > 0) return `${days} hari yang lalu`;
		if (hours > 0) return `${hours} jam yang lalu`;
		if (minutes > 0) return `${minutes} menit yang lalu`;

		return "Baru saja";
	};

	const getInitials = (name: string): string => {
		const nameParts = name.trim().split(" ");

		if (nameParts.length === 1) {
			return nameParts[0][0].toUpperCase();
		}

		return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
	};

	return (
		<div
			style={{
				padding: "0px 0px 12px",
				borderBottom: "1px solid #E8ECF3",
			}}
		>
			<Space
				direction="vertical"
				size={0}
			>
				{!comment.isDeleted ? (
					<div
						style={{
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						{!comment?.status || (comment?.status && comment?.status === "WAITING_APPROVAL") ? (
							<Space>
								<Button
									type="text"
									style={{
										padding: 0,
									}}
									onClick={onClickApprove}
								>
									<CheckOutlined
										style={{
											color: "green",
										}}
									/>
								</Button>
								<Button
									onClick={onClickReject}
									type="text"
									style={{
										padding: 0,
										color: "#dc1b2e",
									}}
								>
									<CloseOutlined />
								</Button>
							</Space>
						) : comment?.status === "PUBLISH" ? (
							<Text
								style={{
									fontSize: 12,
									color: "green",
								}}
							>
								Approved
							</Text>
						) : comment?.status === "REJECTED" ? (
							<Text
								style={{
									fontSize: 12,
									color: "#dc1b2e",
								}}
							>
								Rejected
							</Text>
						) : null}
					</div>
				) : comment?.status === "PUBLISH" ? (
					<div
						style={{
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						<Text
							style={{
								fontSize: 12,
								color: "green",
							}}
						>
							Approved
						</Text>
					</div>
				) : comment?.status === "REJECTED" ? (
					<div
						style={{
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						<Text
							style={{
								fontSize: 12,
								color: "#dc1b2e",
							}}
						>
							Rejected
						</Text>
					</div>
				) : null}

				<Space
					size={12}
					style={{
						alignItems: "flex-start",
					}}
				>
					<Avatar
						style={{ color: "#1E1E1E", fontSize: 16, fontWeight: 600 }}
						size={36}
					>
						{getInitials(comment.name)}
					</Avatar>

					<Space direction="vertical">
						<Space
							direction="horizontal"
							style={{
								display: "flex",
								alignItems: "center",
							}}
						>
							<Text
								style={{
									fontSize: 14,
									fontWeight: 600,
								}}
							>
								{comment.name}
							</Text>
							<div
								style={{
									width: 2,
									height: 2,
									borderRadius: "50%",
									backgroundColor: "gray",
								}}
							/>
							<Text
								style={{
									color: "#8E8E8E",
									fontSize: 10,
								}}
							>
								{comment?.email}
							</Text>
							<div
								style={{
									width: 2,
									height: 2,
									borderRadius: "50%",
									backgroundColor: "gray",
								}}
							/>
							<Text
								style={{
									color: "#8E8E8E",
									fontSize: 10,
								}}
							>
								{calculateTimeAgo(new Date(comment.createdAt))}
							</Text>
						</Space>

						<Paragraph
							style={{
								marginBottom: 0,
								fontSize: 12,
							}}
							key={"expanded-count-" + expandedState.count}
							ellipsis={{
								rows: 4,
								expandable: true,
								symbol: (
									<>
										<br />
										<span
											style={{
												color: "#DC1B2E",
												fontSize: 12,
											}}
										>
											Read More
										</span>
									</>
								),
								onExpand: () =>
									setExpandedState((state) => ({
										expanded: true,
										count: state.count,
									})),
							}}
						>
							{comment.isDeleted === true || comment.status === "REJECTED" ? (
								<Text
									type="secondary"
									italic={!showHideContent}
									style={{
										fontSize: 12,
										color: showHideContent ? "rgba(0, 0, 0, 0.85)" : "#8E8E8E",
									}}
								>
									{showHideContent
										? comment?.comment
										: `This comment has been ${
												comment.isDeleted === true
													? "deleted"
													: comment.status === "REJECTED"
													? "rejected"
													: ""
										  } by admin`}
								</Text>
							) : (
								<>
									{comment.comment}
									{expandedState.expanded && (
										<StyledColapseButton
											onClick={() =>
												setExpandedState((state) => ({
													expanded: false,
													count: state.count + 1,
												}))
											}
										>
											<br />
											Hide
										</StyledColapseButton>
									)}
								</>
							)}
						</Paragraph>

						{(!isReply && comment?.replies.length > 0) ||
						(!isReply && !comment.isDeleted) ||
						(!comment.isDeleted && comment.status !== "REJECTED") ? (
							<Space size={16}>
								{!isReply && comment?.replies.length > 0 && (
									<div
										onClick={onClickShowReply}
										style={{
											alignItems: "center",
											display: "flex",
											gap: 8,
											cursor: "pointer",
										}}
									>
										<Icon
											component={ReplyIcon}
											style={{ fontSize: "14px" }}
										/>
										<Text style={{ cursor: "pointer", fontSize: 12, fontWeight: 600 }}>
											{isOpenReply
												? "Hide Reply"
												: comment.replies.length > 0
												? `See ${comment?.replies?.length} ${
														comment?.replies?.length === 1 ? "Reply" : "Replies"
												  }`
												: "Reply"}
										</Text>
									</div>
								)}

								{!isReply && !comment.isDeleted && (
									<>
										{comment?.replies.length > 0 ? (
											<div onClick={onClickReply}>
												<Text
													style={{
														cursor: "pointer",
														fontSize: 12,
														fontWeight: 600,
														color: "#00133B",
													}}
												>
													Reply
												</Text>
											</div>
										) : (
											<div
												onClick={onClickReply}
												style={{
													alignItems: "center",
													display: "flex",
													gap: 8,
													cursor: "pointer",
												}}
											>
												<Icon
													component={ReplyIcon}
													style={{ fontSize: "14px" }}
												/>
												<Text style={{ cursor: "pointer", fontSize: 12, fontWeight: 600 }}>
													Reply
												</Text>
											</div>
										)}
									</>
								)}

								{!comment.isDeleted && comment.status !== "REJECTED" && (
									<TrashButton
										type="text"
										danger
										onClick={onClickRemove}
									>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}
										>
											<Trash />

											<Typography.Text
												style={{
													fontSize: 12,
													fontWeight: 600,
													color: "#dc1b2e",
												}}
											>
												Remove
											</Typography.Text>
										</div>
									</TrashButton>
								)}
							</Space>
						) : null}
					</Space>
				</Space>
			</Space>
		</div>
	);
}

const StyledColapseButton = styled(Typography.Link)`
	font-weight: 400;
	font-size: 12px;
	color: #dc1b2e !important;
`;

const TrashButton = styled(Button)`
	padding: 0;
`;

const ReplyIcon = () => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M2.84192 9.49715H12.3334V1.49715H1.66671V10.4206L2.84192 9.49715ZM3.30307 10.8305L0.333374 13.1638V0.830485C0.333374 0.462298 0.631854 0.163818 1.00004 0.163818H13C13.3682 0.163818 13.6667 0.462298 13.6667 0.830485V10.1638C13.6667 10.532 13.3682 10.8305 13 10.8305H3.30307Z"
			fill="black"
		/>
	</svg>
);
